﻿$.fn.dxCtrlFichier2Gallery = function custom_dxCtrlFichier2Gallery(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlfichier2gallery dx-ctrl");
        this.createInstance(new cdxCtrlFichier2Gallery(this, option));
    }
    return this;
}

window.cdxCtrlFichier2Gallery = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.css("height", ((container.innerHeight() == 0) ? "" : container.innerHeight() + 'px'))
        container.empty()
        if (option.dataSource.length > 0) {
            option.dataSource.forEach(function (item) {
                delete item.heightRatio
                delete item.widthRatio
            })
            option.dataSource[0].heightRatio = 2
            option.dataSource[0].widthRatio = 2
        }
        $("<div/>").appendTo(container).dxTileView({
            dataSource: option.dataSource,
            itemTemplate: function (itemData, itemIndex, itemElement) {
                const $image = $('<div>')
                    .addClass('image')
                    .css('background-image', `url(${itemData.url})`);
                itemElement.css("position", "relative")

                var fichier = new cFichier(option.bddCtrl, itemData.url)
                var $DivName = $("<div title='" + fichier.mGetNom().replace(/'/g, '&#39;') + "' style='position:absolute;width:100%;border-bottom-left-radius:10px;border-bottom-right-radius:10px;bottom:0;left:0;text-overflow:ellipsis;overflow:hidden;background-color:rgba(0,0,0,0.3);padding:0 5px;white-space:nowrap;'>" + fichier.mGetNom() + "</div>").appendTo(itemElement)

                if (!option.readOnly && typeof option.onDeleteFiles != "undefined") {
                    $("<div style='color:" + theme.backgroundcolorAccent + ";position:absolute;top:3px;right:3px;'/>").appendTo(itemElement).dxCtrlButtonImage({
                        icon: "fas fa-window-close",
                        txtTooltip: "Supprimer le fichier joint",
                        padding: 2,
                        fontSize: 18,
                        onClick: function (e) {
                            isDirty = true
                            e.stopPropagation()
                            option.onDeleteFiles([itemData])
                            $DivFile.remove()
                        }
                    })
                }

                itemElement.on("click", function (e) {
                    e.stopPropagation()
                    option.onClickFile(itemData)
                })
            }
        })

        container.css("height", "")
    }

    this.mAddNewItemData = function (lstNewItemData) {

    }

    this.mRepaint = function () { mConstruit() }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();
}